import axios from 'axios';

//creating an instance of axios to get the api from our back-end  
//const API = axios.create({ baseURL: 'http://localhost:5000/' });
const API = axios.create({ baseURL: 'https://memories-backend-mhe7.onrender.com/' });


/*axios interceptors to intercept requests or responses before they are handled ,
 so we first check the token in the headers of the auth request and verify if token is valid */
API.interceptors.request.use((req) => {
    if (localStorage.getItem('profile')) {
         req.headers.Authorization = `Bearer ${JSON.parse(localStorage.getItem('profile')).token}`;  }  
    return req;
  });

//api (Endpoints) fuctions [the order is important]
export const fetchPost = (id)=>API.get(`/posts/${id}`) ;      //get a single post request
export const fetchPosts = (page)=>API.get(`/posts?page=${page}`) ;      //get a page posts request
export const fetchPostsBySearch = (searchQuery)=>API.get(`/posts/search?searchQuery=${searchQuery.search || 'none'}&tags=${searchQuery.tags}`) ;   //get searched-posts request
export const createPost = (newPost)=>API.post('/posts',newPost) ;       //create a post request
export const likePost = (id)=>API.patch(`/posts/${id}/likePost`) ;    //like a post request
export const commentPost = (userComment, id) => API.post(`/posts/${id}/commentPost`, { userComment}) ;    //comment on a post request
export const updatePost = (id,updatedPost)=>API.patch(`/posts/${id}`,updatedPost) ;    //update a post request
export const deletePost = (id)=>API.delete(`/posts/${id}`) ;    //delete a post request


//signUp & signIn user request  
export const signIn = (formData)=>API.post('/user/signin', formData) ;
export const signUp = (formData)=>API.post('/user/signup', formData) ;     